import * as React from 'react'
import { Check, ChevronDown } from 'lucide-react'
import { Select as SelectPrimitive } from 'radix-ui'

import { cn } from '@shared/ui/lib/utils'
import './select-menu.css'

const SelectMenu = SelectPrimitive.Root
const SelectMenuGroup = SelectPrimitive.Group
const SelectMenuValue = SelectPrimitive.Value

const SelectMenuTrigger = React.forwardRef<
  React.ComponentRef<typeof SelectPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof SelectPrimitive.Trigger>
>(function SelectMenuTrigger({ children, className, ...props }, ref) {
  return (
    <SelectPrimitive.Trigger
      className={cn('lmsSelectMenuTrigger', className)}
      data-slot="select-menu-trigger"
      ref={ref}
      {...props}
    >
      {children}
      <SelectPrimitive.Icon asChild>
        <ChevronDown aria-hidden="true" className="lmsSelectMenuTriggerIcon" />
      </SelectPrimitive.Icon>
    </SelectPrimitive.Trigger>
  )
})

const SelectMenuContent = React.forwardRef<
  React.ComponentRef<typeof SelectPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof SelectPrimitive.Content>
>(function SelectMenuContent({ children, className, position = 'popper', sideOffset = 6, ...props }, ref) {
  return (
    <SelectPrimitive.Portal>
      <SelectPrimitive.Content
        className={cn('lmsSelectMenuContent', className)}
        data-slot="select-menu-content"
        position={position}
        ref={ref}
        sideOffset={sideOffset}
        {...props}
      >
        <SelectPrimitive.Viewport className="lmsSelectMenuViewport">
          {children}
        </SelectPrimitive.Viewport>
      </SelectPrimitive.Content>
    </SelectPrimitive.Portal>
  )
})

const SelectMenuItem = React.forwardRef<
  React.ComponentRef<typeof SelectPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof SelectPrimitive.Item>
>(function SelectMenuItem({ children, className, ...props }, ref) {
  return (
    <SelectPrimitive.Item
      className={cn('lmsSelectMenuItem', className)}
      data-slot="select-menu-item"
      ref={ref}
      {...props}
    >
      <span className="lmsSelectMenuItemIndicator" data-slot="select-menu-item-indicator">
        <SelectPrimitive.ItemIndicator>
          <Check aria-hidden="true" />
        </SelectPrimitive.ItemIndicator>
      </span>
      <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
    </SelectPrimitive.Item>
  )
})

export {
  SelectMenu,
  SelectMenuContent,
  SelectMenuGroup,
  SelectMenuItem,
  SelectMenuTrigger,
  SelectMenuValue,
}
